const SmallGridIcon = () => {
  return (
    <svg
      height="22"
      width="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <>
        <rect x="5" y="4.75" width="12" height="10" fill="currentColor" />
        <rect x="5" y="16.25" width="12" height="1" fill="currentColor" />
      </>
    </svg>
  );
};

export default SmallGridIcon;
